// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['sk_SK']  = {
  "name": "sk_SK",
  "day": {
    "abbrev": [
      "ned",
      "pon",
      "uto",
      "str",
      "štv",
      "pet",
      "sob"
    ],
    "full": [
      "nedeľa",
      "pondelok",
      "utorok",
      "streda",
      "štvrtok",
      "piatok",
      "sobota"
    ]
  },
  "month": {
    "abbrev": [
      "jan",
      "feb",
      "mar",
      "apr",
      "máj",
      "jún",
      "júl",
      "aug",
      "sept",
      "okt",
      "nov",
      "dec"
    ],
    "full": [
      "január",
      "február",
      "marec",
      "apríl",
      "máj",
      "jún",
      "júl",
      "august",
      "september",
      "október",
      "november",
      "december"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d. %m. %Y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %T %Z",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

